import { render, staticRenderFns } from "./activityCourseManage.vue?vue&type=template&id=88a427f2&scoped=true&"
import script from "./activityCourseManage.vue?vue&type=script&lang=js&"
export * from "./activityCourseManage.vue?vue&type=script&lang=js&"
import style0 from "./activityCourseManage.vue?vue&type=style&index=0&id=88a427f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a427f2",
  null
  
)

export default component.exports